import { Outlet } from 'react-router-dom';
import { AppLayout } from '@/components/templates/AppLayout';
import {
  Home,
  ListMusic,
  MessagesSquare,
  Users,
  Building2,
  BarChart3,
  BellRing,
  Tags,
  Gift,
  Mail,
  MessageSquareText,
} from 'lucide-react';
import { ROUTES } from '@/constants/routes';
import type { NavItem } from '@/components/organisms/Sidebar';

const BACKOFFICE_NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard', path: ROUTES.BACKOFFICE.DASHBOARD, icon: Home },
  { label: 'Historias', path: ROUTES.BACKOFFICE.STORIES, icon: ListMusic },
  { label: 'Conversaciones', path: ROUTES.BACKOFFICE.CONVERSATIONS, icon: MessagesSquare },
  { label: 'Categorías', path: ROUTES.BACKOFFICE.CATEGORIES, icon: Tags },
  { label: 'Recompensas', path: ROUTES.BACKOFFICE.REWARDS, icon: Gift },
  { label: 'Usuarios', path: ROUTES.BACKOFFICE.USERS, icon: Users },
  { label: 'Empresas', path: ROUTES.BACKOFFICE.COMPANIES, icon: Building2 },
  { label: 'Preferencias', path: ROUTES.BACKOFFICE.ANALYTICS_PREFERENCES, icon: BarChart3 },
  { label: 'Salud notificaciones', path: ROUTES.BACKOFFICE.NOTIFICATIONS_HEALTH, icon: BellRing },
  { label: 'Emails', path: ROUTES.BACKOFFICE.EMAILS, icon: Mail },
  { label: 'Feedback', path: ROUTES.BACKOFFICE.FEEDBACK, icon: MessageSquareText },
];

export function BackofficeLayout() {
  return (
    <AppLayout navItems={BACKOFFICE_NAV_ITEMS} navRole="backoffice">
      <Outlet />
    </AppLayout>
  );
}

export default BackofficeLayout;
